import { CopyableText, Skeleton } from '@sixui/ui';
import { useTranslation } from 'react-i18next';

import type { IContainerProps } from '~/components/utils/Container';
import { Link } from '~/components/atoms/Link';
import { ContentBlock } from '~/components/molecules/ContentBlock';
import { useAppRegion } from '~/hooks/useAppRegion';
import { useAppQuery } from '~/lib/api/modules/Apps/hooks/useAppQuery';
import { getAppSettings } from '~/lib/appSettings';

export type IAppInfoProps = IContainerProps & {
  appId: string;
};

export const AppInfo: React.FC<IAppInfoProps> = (props) => {
  const { sx, appId } = props;
  const { t } = useTranslation();

  const appSettings = getAppSettings();
  const appRegion = useAppRegion();
  const appQuery = useAppQuery({ appId });

  const previewLink = `${appSettings.environment.url}/${appRegion}/preview/${appId}.${appRegion}`;
  const protocol = appQuery.data?.protocol;

  return (
    <ContentBlock sx={sx}>
      <ContentBlock.InfoList first>
        <ContentBlock.InfoListItem label={t('AppInfo.field.id.label')}>
          <CopyableText>{appId}</CopyableText>
        </ContentBlock.InfoListItem>

        <ContentBlock.InfoListItem label={t('AppInfo.field.protocol.label')}>
          <Skeleton
            loaded={!appQuery.isLoading}
            length={{
              min: 12,
              max: 24,
            }}
          >
            <CopyableText>{protocol}</CopyableText>
          </Skeleton>
        </ContentBlock.InfoListItem>

        <ContentBlock.InfoListItem label={t('AppInfo.field.previewLink.label')}>
          <Link to={previewLink} target="_blank" noExternalIcon>
            {previewLink}
          </Link>{' '}
          <CopyableText text={previewLink} />
        </ContentBlock.InfoListItem>
      </ContentBlock.InfoList>
    </ContentBlock>
  );
};
